module.exports = __webpack_public_path__ + "fonts/DidotLH-Italic.207dfa24.ttf";